import React, { useRef, useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import DashboardService from '../../services/dashboard/Dashboard';

const PoolAchievers = () => {
    const observer = useRef();

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
        isError
    } = useInfiniteQuery({
        queryKey: ['get-referral-pool-achievers'],
        queryFn: ({ pageParam = 1 }) => DashboardService.GetReferralPoolAchievers(pageParam, 10),
        getNextPageParam: (lastPage, allPages) => {
            // If last page has data and is full (10 items per page), there might be more
            if (lastPage && lastPage.length === 10) {
                return allPages.length + 1;
            }
            return undefined; // No more pages
        },
        enabled: true,
    });

    // Flatten all pages into a single array
    console.log("🚀 ~ PoolAchievers ~ data:", data)
    const allUsers = data?.pages?.flat() || [];

    // Last element ref for intersection observer
    const lastUserElementRef = useCallback(node => {
        if (isFetchingNextPage) return;
        if (observer.current) observer.current.disconnect();
        
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasNextPage) {
                fetchNextPage();
            }
        });
        
        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);

    if (isError) {
        return (
            <div className="col-md-12">
                <div className="joinings_viewBox teamperfomance mb-3" style={{ minHeight: '400px' }}>
                    <div className="joinings_viewBox_head">
                        <h5>Referral Pool Achievers</h5>
                    </div>
                    <div className="text-center py-3">
                        <p className="text-danger">Error loading referral pool achievers</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-md-6">
            <div className="joinings_viewBox teamperfomance mb-3" style={{ minHeight: '400px' }}>
                <div className="joinings_viewBox_head">
                    <h5>Referral Pool Achievers</h5>
                </div>
                <div className='row' style={{ overflowY: 'scroll', maxHeight: '300px' }}>
                    {allUsers?.map((user, index) => (
                        <div 
                            className="col-md-4 mb-3" 
                            key={user.id || `user-${index}`}
                            ref={allUsers.length === index + 1 ? lastUserElementRef : null}
                        >
                            <div className='row rank-user-container'>
                                <div className='col-md-6 rank-user-image'>
                                    <img
                                        style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #fff' }}
                                        src={user.image ?? "/images/user-profile.png"}
                                        alt=""
                                    />
                                </div>
                                <div className='col-md-6 rank-user-text'>{user.name}</div>
                            </div>
                        </div>
                    ))}
                    
                    {/* Initial loading */}
                    {isLoading && (
                        <div className="col-md-12 text-center py-3">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    )}
                    
                    {/* Loading next page */}
                    {isFetchingNextPage && (
                        <div className="col-md-12 text-center py-3">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="sr-only">Loading more...</span>
                            </div>
                        </div>
                    )}
                    
                    {/* End of data indicator */}
                    {!hasNextPage && allUsers.length > 0 && (
                        <div className="col-md-12 text-center py-3">
                            <p className="text-muted">No more users to load</p>
                        </div>
                    )}
                    
                    {/* No data indicator */}
                    {!isLoading && allUsers.length === 0 && (
                        <div className="col-md-12 text-center py-3">
                            <p className="text-muted">No Referral Pool Achievers found</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PoolAchievers;